export const headerBottom = 12;
export const sectionBottom = 16;
export const mdHeadingBottom = 4;
export const tParaBottom = 6;
export const tBottom = 2;
export const fullWidthTextSectionMargin = [null, null, 12, 36];
